import { useEffect } from "react";
import { useHistory } from "react-router";
import { getCurrentUser, logout } from "../services/auth";

// A Higher Order Component for requiring authentication
export const requireAuth = (Component: any) => {
	return (props: any) => {
		const history = useHistory();

		useEffect(() => {
			// Redirect if not signed in
			getCurrentUser().then((user: any) => {
				if (!user) {
					logout();
					history.replace("/login");
				}
			});
		});

		// Show loading indicator
		// We're either loading (user is null) or we're about to redirect (user is false)
		// if (!auth.user) {
		//   //loading
		// 	return null;//<PageLoader />;
		// }

		// Render component now that we have user
		return <Component {...props} />;
	};
};

export default requireAuth;
